import { Link } from 'react-router-dom';
import { useLocale } from '@/context/LocaleContext';
import { RANKING_TABS, type RankingCategory } from './rankingTypes';
export function RankingTabs({active}:{active:RankingCategory}) {
  const {t}=useLocale();
  return <nav className="ranking-category-tabs" aria-label={t('ranking')}>
    {RANKING_TABS.map(entry=><Link key={entry.slug} to={`/ranking/${entry.slug}`} aria-current={active===entry.slug?'page':undefined}
      className={`ranking-category-tab${active===entry.slug?' is-active':''}${entry.slug==='season'?' is-season':''}`}>
      <i className={`fa fa-${entry.icon}`} aria-hidden="true" />{entry.label}
    </Link>)}
  </nav>;
}
